<template>
<body data-sidebar="dark">
<title>FLOCKR | Escrow</title>
<div class="esc-root">
  <div class="esc-topbar">
    <div class="container d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center gap-3">
        <a href="javascript:void(0)" @click="$router.push('/')"><img src="assets/images/flockr_logo.png" alt="Flockr" style="height:32px;" /></a>
        <span style="color:var(--fm-h,#F5F0E8);font-weight:600;">Escrow</span>
      </div>
      <div class="d-flex gap-2">
        <a href="javascript:void(0)" @click="$router.push('/wallet')" class="btn btn-sm btn-outline-warning"><i class="mdi mdi-wallet me-1"></i>Wallet</a>
        <a href="javascript:void(0)" @click="$router.push('/orders')" class="btn btn-sm btn-outline-secondary">Orders</a>
        <a href="javascript:void(0)" @click="$router.push('/dashboard')" class="btn btn-sm btn-outline-secondary">Dashboard</a>
      </div>
    </div>
  </div>
  <div class="container esc-container">
    <div v-if="loading" class="text-center py-5"><div class="spinner-border text-warning"></div></div>
    <template v-else>
      <div class="esc-stats-row">
        <div class="esc-stat-card">
          <div class="esc-stat-icon" style="background:rgba(80,200,120,0.1);"><i class="mdi mdi-shield-lock" style="color:#50C878;"></i></div>
          <div><div class="esc-stat-val" style="color:#50C878;">KES {{ fN(stats.totalHeld) }}</div><div class="esc-stat-lbl">In Escrow</div></div>
          <div class="esc-stat-count">{{ stats.fundedCount }}</div>
        </div>
        <div class="esc-stat-card">
          <div class="esc-stat-icon" style="background:rgba(80,165,241,0.1);"><i class="mdi mdi-check-decagram" style="color:#50a5f1;"></i></div>
          <div><div class="esc-stat-val" style="color:#50a5f1;">KES {{ fN(stats.totalReleased) }}</div><div class="esc-stat-lbl">Released</div></div>
          <div class="esc-stat-count">{{ stats.releasedCount }}</div>
        </div>
        <div class="esc-stat-card">
          <div class="esc-stat-icon" style="background:rgba(255,171,0,0.1);"><i class="mdi mdi-undo" style="color:#FFAB00;"></i></div>
          <div><div class="esc-stat-val" style="color:#FFAB00;">KES {{ fN(stats.totalRefunded) }}</div><div class="esc-stat-lbl">Refunded</div></div>
          <div class="esc-stat-count">{{ stats.refundedCount }}</div>
        </div>
      </div>

      <div class="esc-role-toggle mb-3">
        <button :class="{ active: role === '' }" @click="role=''; fetchEscrow()">All</button>
        <button :class="{ active: role === 'buyer' }" @click="role='buyer'; fetchEscrow()"><i class="mdi mdi-cart me-1"></i>Buying</button>
        <button :class="{ active: role === 'seller' }" @click="role='seller'; fetchEscrow()"><i class="mdi mdi-tag me-1"></i>Selling</button>
      </div>

      <div class="esc-tabs mb-4">
        <button v-for="tab in statusTabs" :key="tab.value" :class="{ active: activeTab === tab.value }" @click="activeTab = tab.value">
          {{ tab.label }}
          <span v-if="getCount(tab.value)" class="esc-tab-badge">{{ getCount(tab.value) }}</span>
        </button>
      </div>

      <div v-if="filtered.length === 0" class="text-center py-5">
        <i class="mdi mdi-shield-outline" style="font-size:48px;color:var(--fm-s,#2A2520);"></i>
        <p class="mt-2" style="color:var(--fm-s,#6B6356);">No escrow transactions</p>
      </div>

      <div v-else>
        <div v-for="e in filtered" :key="e.id" class="esc-card" @click="$router.push('/orders/' + e.order_id)">
          <div class="d-flex align-items-start gap-3">
            <div class="esc-card-img">
              <img v-if="e.listing_photo" :src="pu(e.listing_photo)" />
              <i v-else class="mdi mdi-shield-lock" style="font-size:22px;color:#50C878;"></i>
            </div>
            <div class="flex-fill">
              <div class="d-flex align-items-center justify-content-between mb-1">
                <span class="esc-order-num">#{{ e.order_number }}</span>
                <span class="esc-status" :class="'es-' + e.status">{{ fSt(e.status) }}</span>
              </div>
              <div class="esc-card-title">{{ e.listing_title || 'Transaction' }}</div>
              <div class="esc-card-meta">
                <span v-if="isBuyer(e)">Seller: {{ e.seller_name }}</span>
                <span v-else>Buyer: {{ e.buyer_name }}</span>
              </div>
            </div>
            <div class="text-end">
              <div class="esc-card-amount">KES {{ fN(e.amount) }}</div>
              <div class="esc-card-date">{{ fmtD(e.created_at) }}</div>
            </div>
          </div>

          <div v-if="e.status === 'funded' && isBuyer(e)" class="esc-hint shield">
            <i class="mdi mdi-shield-check me-1"></i>Your payment is held safely until you confirm delivery
          </div>
          <div v-if="e.status === 'funded' && !isBuyer(e)" class="esc-hint info">
            <i class="mdi mdi-information me-1"></i>Payment received in escrow. Deliver to release funds.
          </div>
          <div v-if="e.status === 'released'" class="esc-hint ok">
            <i class="mdi mdi-check-circle me-1"></i>Released {{ e.released_at ? fmtD(e.released_at) : '' }}
            <span v-if="e.release_trigger" style="opacity:0.7;"> &middot; {{ fTrigger(e.release_trigger) }}</span>
          </div>
          <div v-if="e.status === 'refunded'" class="esc-hint warn">
            <i class="mdi mdi-undo me-1"></i>Refunded {{ e.refunded_at ? fmtD(e.refunded_at) : '' }}
          </div>
          <div v-if="e.status === 'disputed'" class="esc-hint danger">
            <i class="mdi mdi-gavel me-1"></i>Under dispute resolution
          </div>
          <div v-if="e.status === 'pending'" class="esc-hint warn">
            <i class="mdi mdi-clock-outline me-1"></i>Awaiting payment
          </div>
        </div>
      </div>

      <div class="esc-info-box mt-4">
        <h6 style="color:var(--fm-h,#F5F0E8);font-size:13px;font-weight:700;margin-bottom:8px;"><i class="mdi mdi-shield-check me-2" style="color:#50C878;"></i>How Escrow Works</h6>
        <div class="esc-info-steps">
          <div><span class="esc-info-num">1</span>Buyer pays &mdash; funds held in escrow</div>
          <div><span class="esc-info-num">2</span>Seller delivers the livestock</div>
          <div><span class="esc-info-num">3</span>Buyer inspects and confirms receipt</div>
          <div><span class="esc-info-num">4</span>Funds released to seller automatically</div>
        </div>
        <p style="color:var(--fm-s,#6B6356);font-size:11px;margin:8px 0 0;">Disputes can be raised within 48 hours of delivery for a full refund.</p>
      </div>
    </template>
  </div>
</div>
</body>
</template>
<style>

/* === GLOBAL THEME === */
html[data-theme="light"] body { background:#FFFFFF!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-card,html[data-theme="light"] .p2c,html[data-theme="light"] .ld-section,html[data-theme="light"] .ld-action-card,html[data-theme="light"] .ld-seller-card,html[data-theme="light"] .ld-info-card,html[data-theme="light"] .ld-related-card { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-overlay .fm-modal,html[data-theme="light"] .ad-overlay .ad-modal { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-input,html[data-theme="light"] .fm-select { background:#F7F5F2!important; border-color:#E0D8D0!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-label { color:#555!important; }
html[data-theme="dark"] body { background:#0A0A0A!important; color:#F5F0E8!important; }
</style>
<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
html[data-theme="light"] body{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .card{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .card-body{color:#1A1A1A!important}
html[data-theme="light"] .modal-content{background:#FFFFFF!important;border-color:#E8E2DA!important;color:#1A1A1A!important}
html[data-theme="light"] .form-control,html[data-theme="light"] .form-select{background:#FFFFFF!important;border-color:#E0D8D0!important;color:#1A1A1A!important}
html[data-theme="light"] .table{color:#1A1A1A!important}
html[data-theme="light"] .table th{color:#555!important;border-color:#E8E2DA!important}
html[data-theme="light"] .table td{border-color:#F0EBE4!important}
html[data-theme="light"] [style*="color:#F5F0E8"]{color:#1A1A1A!important}
html[data-theme="light"] [style*="color:#6B6356"]{color:#777!important}
html[data-theme="light"] [style*="color:#A09888"]{color:#555!important}
html[data-theme="light"] [style*="background:#0F0F0F"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#141414"]{background:#FFFFFF!important}
html[data-theme="light"] [style*="background:#1E1E1E"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="background:#0A0A0A"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#1a1510"]{background:#FFF8F0!important}
html[data-theme="light"] [style*="background:#1A1A1A"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="border:1px solid #1E1E1E"]{border-color:#E8E2DA!important}
html[data-theme="light"] [style*="border:1px solid #2A2520"]{border-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1A1A1A"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1E1E1E"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #2A2520"]{border-bottom-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-top:1px solid #2A2520"]{border-top-color:#E0D8D0!important}
html[data-theme="light"] [style*="color:#BFA164"]{color:#BFA164!important}
html[data-theme="light"] [style*="color:#50C878"]{color:#50C878!important}
html[data-theme="light"] [style*="color:#4FC3F7"]{color:#4FC3F7!important}
html[data-theme="light"] [style*="color:#FF6B6B"]{color:#FF6B6B!important}
html[data-theme="light"] [style*="color:#FF9800"]{color:#FF9800!important}
html[data-theme="light"] [style*="color:#CE93D8"]{color:#CE93D8!important}
</style>
<style scoped>
.esc-root{background:#0A0A0A;min-height:100vh;color:var(--fm-h,#F5F0E8)}
.esc-topbar{position:sticky;top:0;z-index:100;padding:12px 0;background:rgba(10,10,10,0.95);backdrop-filter:blur(10px);border-bottom:1px solid var(--fm-br,#1E1E1E)}
.esc-container{padding-top:80px;padding-bottom:60px;max-width:800px}
.esc-stats-row{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin-bottom:20px}
.esc-stat-card{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:12px;padding:16px;display:flex;align-items:center;gap:12px;position:relative}
.esc-stat-icon{width:40px;height:40px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:20px;flex-shrink:0}
.esc-stat-val{font-size:16px;font-weight:700}
.esc-stat-lbl{font-size:11px;color:var(--fm-s,#6B6356)}
.esc-stat-count{position:absolute;top:10px;right:12px;font-size:20px;font-weight:800;color:#1E1E1E}
.esc-role-toggle{display:flex;border-radius:10px;overflow:hidden;border:1px solid var(--fm-br,#2A2520)}
.esc-role-toggle button{flex:1;padding:10px;background:var(--fm-bg1,#141414);border:none;color:var(--fm-m,#A09888);font-size:13px;font-weight:600;cursor:pointer;transition:all .2s}
.esc-role-toggle button.active{background:rgba(80,200,120,0.1);color:#50C878}
.esc-tabs{display:flex;gap:6px;overflow-x:auto;scrollbar-width:none}
.esc-tabs::-webkit-scrollbar{display:none}
.esc-tabs button{white-space:nowrap;padding:6px 14px;border-radius:16px;border:1px solid var(--fm-br,#2A2520);background:var(--fm-bg1,#141414);color:var(--fm-m,#A09888);font-size:12px;cursor:pointer;transition:all .2s}
.esc-tabs button.active{background:rgba(80,200,120,0.1);border-color:#50C878;color:#50C878}
.esc-tab-badge{background:#50C878;color:#0A0A0A;font-size:10px;font-weight:700;padding:1px 6px;border-radius:10px;margin-left:4px}
.esc-card{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:12px;padding:16px;margin-bottom:12px;cursor:pointer;transition:all .2s}
.esc-card:hover{border-color:#50C878;transform:translateY(-1px)}
.esc-card-img{width:50px;height:50px;border-radius:8px;overflow:hidden;background:var(--fm-bg2,#0F0F0F);flex-shrink:0;display:flex;align-items:center;justify-content:center}
.esc-card-img img{width:100%;height:100%;object-fit:cover}
.esc-order-num{font-size:11px;color:var(--fm-s,#6B6356);font-weight:600;font-family:monospace}
.esc-card-title{font-size:14px;font-weight:600;color:var(--fm-h,#F5F0E8)}
.esc-card-meta{font-size:11px;color:var(--fm-s,#6B6356);margin-top:2px}
.esc-card-amount{font-size:16px;font-weight:700;color:#50C878}
.esc-card-date{font-size:10px;color:var(--fm-s,#6B6356);margin-top:2px}
.esc-status{font-size:10px;font-weight:600;padding:2px 8px;border-radius:10px;text-transform:capitalize}
.es-pending{background:rgba(255,171,0,0.15);color:#FFAB00}
.es-funded{background:rgba(80,200,120,0.15);color:#50C878}
.es-held{background:rgba(80,200,120,0.15);color:#50C878}
.es-released{background:rgba(80,165,241,0.15);color:#50a5f1}
.es-refunded{background:rgba(255,171,0,0.15);color:#FFAB00}
.es-partially_refunded{background:rgba(255,171,0,0.15);color:#FFAB00}
.es-disputed{background:rgba(255,107,107,0.15);color:#FF6B6B}
.esc-hint{font-size:11px;padding:8px 12px;border-radius:8px;margin-top:10px}
.esc-hint.shield{background:rgba(80,200,120,0.06);color:#50C878}
.esc-hint.ok{background:rgba(80,200,120,0.06);color:#50C878}
.esc-hint.info{background:rgba(80,165,241,0.06);color:#50a5f1}
.esc-hint.warn{background:rgba(255,171,0,0.06);color:#FFAB00}
.esc-hint.danger{background:rgba(255,107,107,0.06);color:#FF6B6B}
.esc-info-box{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:12px;padding:20px}
.esc-info-steps{display:flex;flex-direction:column;gap:8px}
.esc-info-steps>div{font-size:12px;color:var(--fm-m,#A09888);display:flex;align-items:center;gap:10px}
.esc-info-num{width:22px;height:22px;border-radius:50%;background:rgba(80,200,120,0.1);color:#50C878;font-size:11px;font-weight:700;display:flex;align-items:center;justify-content:center;flex-shrink:0}
@media (max-width:600px){.esc-stats-row{grid-template-columns:1fr}.esc-stat-card{padding:12px}}
</style>
<script>
import { executeJson, flocker, uploads } from "@/api";
export default {
  name: "EscrowDashboard",
  data() {
    return {
      darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',

      loading: true, role: '', activeTab: 'all', transactions: [],
      stats: { totalHeld:0, totalReleased:0, totalRefunded:0, pendingCount:0, fundedCount:0, releasedCount:0, refundedCount:0, disputedCount:0 },
      statusTabs: [
        { label: 'All', value: 'all' },{ label: 'In Escrow', value: 'funded' },
        { label: 'Released', value: 'released' },{ label: 'Refunded', value: 'refunded' },
        { label: 'Pending', value: 'pending' },{ label: 'Disputed', value: 'disputed' }
      ]
    };
  },
  computed: {
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'},
    themeCardStyle(){return this.darkMode?'background:#141414!important;border:1px solid #1E1E1E!important;':'background:#FFFFFF!important;border:1px solid #E8E2DA!important;'},
    themeInputStyle(){return this.darkMode?'background:#0F0F0F;border:1px solid #2A2520;color:#F5F0E8;':'background:#FFFFFF;border:1px solid #E0D8D0;color:#1A1A1A;'},

    filtered() {
      if (this.activeTab === 'all') return this.transactions;
      var t = this.activeTab;
      return this.transactions.filter(function(e) { return e.status === t; });
    }
  },
  mounted() {
    // Apply global theme
    var t=localStorage.getItem('flockr_theme')||'dark';window.__flockrSetTheme(t);
 this.fetchEscrow(); },
  methods: {
    pu(p) { if (!p) return ''; if (p.startsWith && p.startsWith('http')) return p; return uploads + String(p).replace('uploads/', ''); },
    fN(v) { return v ? Number(v).toLocaleString() : '0'; },
    fmtD(d) { return d ? new Date(d).toLocaleDateString('en-KE', { day: 'numeric', month: 'short', year: 'numeric' }) : ''; },
    fSt(s) { return (s || '').replace(/_/g, ' '); },
    fTrigger(t) {
      var m = { buyer_confirmed: 'Buyer confirmed', auto_release: 'Auto-released', admin_release: 'Admin released', dispute_resolution: 'Dispute resolved' };
      return m[t] || t;
    },
    isBuyer(e) { return String(e.buyer_id) === sessionStorage.getItem('userId'); },
    getCount(st) {
      if (st === 'all') return this.transactions.length;
      return this.transactions.filter(function(e) { return e.status === st; }).length;
    },
    async fetchEscrow() {
      this.loading = true;
      var userId = sessionStorage.getItem('userId');
      if (!userId) { this.$router.push('/login'); return; }
      try {
        var f = new FormData();
        f.append('function', 'getMyEscrow');
        f.append('userId', userId);
        if (this.role) f.append('role', this.role);
        var r = await executeJson(f, flocker);
        if (r.data && r.data.success) {
          this.transactions = r.data.data.escrow || [];
          this.stats = r.data.data.stats || this.stats;
        }
      } catch (e) { console.error(e); }
      finally { this.loading = false; }
    }
  }
};
</script>
